import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import { ProtectedRoute, FullScreenSpinner } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import Login from "@/pages/Login";
import CompleteProfile from "@/pages/CompleteProfile";
import Profile from "@/pages/Profile";
import Board from "@/pages/manager/Board";
import Create from "@/pages/manager/Create";
import Reports from "@/pages/manager/Reports";
import Rates from "@/pages/manager/Rates";
import Analytics from "@/pages/manager/Analytics";
import Pending from "@/pages/driver/Pending";
import History from "@/pages/driver/History";

const MANAGER_PLANT_ROLES = ["manager", "plant"];
const MANAGER_ROLES = ["manager"];
const DRIVER_ROLES = ["driver"];

function RootRedirect() {
  const { user, needsRole, loading } = useAuth();
  if (loading) return <FullScreenSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (needsRole || !user.role) return <Navigate to="/complete-profile" replace />;
  return <Navigate to={user.role === "driver" ? "/pending" : "/board"} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />

          {/* Any authenticated user */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Route>

          {/* Manager + Plant */}
          <Route element={<ProtectedRoute roles={MANAGER_PLANT_ROLES} />}>
            <Route element={<AppLayout />}>
              <Route path="/board" element={<Board />} />
              <Route path="/create" element={<Create />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/analytics" element={<Analytics />} />
            </Route>
          </Route>

          {/* Manager only */}
          <Route element={<ProtectedRoute roles={MANAGER_ROLES} />}>
            <Route element={<AppLayout />}>
              <Route path="/rates" element={<Rates />} />
            </Route>
          </Route>

          {/* Driver */}
          <Route element={<ProtectedRoute roles={DRIVER_ROLES} />}>
            <Route element={<AppLayout />}>
              <Route path="/pending" element={<Pending />} />
              <Route path="/history" element={<History />} />
            </Route>
          </Route>

          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
